import { createProvider } from '@nvision/services/data-provider';

import * as api from './api';
import { normalizePreClaimsDispositionMethodList } from './normalize';

export const fetchPreClaimsDispositionMethodList = createProvider(api.fetchPreClaimsDispositionMethodList)
  .andThen((res) => normalizePreClaimsDispositionMethodList(res))
  .andCatch((error) => {
    if (error instanceof Error && error.name === 'AbortError') {
      console.warn('Fetch list aborted');
    } else {
      console.error('Fetch list was failed:', error);
    }
    throw error;
  });
